import { createClient } from '@supabase/supabase-js';
import { config } from './config';

// Anonymous client. Only used for the public read RPCs (form options + slots).
// All writes go through the submit-lead edge function (service role).
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  db: { schema: 'forms' },
  auth: { persistSession: false, autoRefreshToken: false },
});
